import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-[#000099] mb-2">
        Personvernerklæring for Ryfylke Utleie AS
      </h1>
      <p className="text-sm text-gray-500 mb-8">
        Sist oppdatert: {new Date().toLocaleDateString("no-NO")}
      </p>

      <p className="mb-6">
        Ryfylke Utleie AS er forpliktet til å beskytte ditt personvern. Denne
        erklæringen beskriver hvordan vi samler inn, bruker, lagrer og
        beskytter personopplysninger når du besøker vår nettside eller benytter
        våre tjenester.
      </p>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        1. Behandlingsansvarlig
      </h2>
      <p className="mb-4">
        Behandlingsansvarlig er Ryfylke Utleie AS{" "}
        <span className="text-gray-500">(org.nr. 917538379)</span>.
        Kontaktinformasjon finner du nederst på siden.
      </p>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        2. Hvilke opplysninger vi samler inn
      </h2>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>
          <strong>Kontaktinformasjon:</strong> navn, e-postadresse, telefon,
          adresse.
        </li>
        <li>
          <strong>Brukerinformasjon:</strong> IP-adresse, nettleser, enhet,
          besøksstatistikk og hvordan nettstedet brukes.
        </li>
        <li>
          <strong>Transaksjonsinformasjon:</strong> bestillinger og betalinger.
        </li>
        <li>
          <strong>Kommunikasjonsdata:</strong> henvendelser på e-post, telefon
          eller andre kanaler.
        </li>
      </ul>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        3. Formål med behandlingen
      </h2>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>Levere og administrere tjenester/bestillinger.</li>
        <li>Forbedre nettsted og brukeropplevelse.</li>
        <li>Gi kundeservice og svare på henvendelser.</li>
        <li>Markedsføring (kun med gyldig samtykke).</li>
        <li>Oppfylle lovpålagte krav (for eksempel regnskapsregler).</li>
      </ul>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        4. Rettslig grunnlag
      </h2>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li><em>Avtale</em> – når det er nødvendig for å gjennomføre en leieavtale.</li>
        <li><em>Samtykke</em> – for eksempel til nyhetsbrev/markedsføring.</li>
        <li><em>Rettslig plikt</em> – når lov krever behandling/lagring.</li>
        <li><em>Berettiget interesse</em> – forbedring av tjenester og sikkerhet.</li>
      </ul>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        5. Lagringstid
      </h2>
      <p className="mb-4">
        Vi lagrer personopplysninger kun så lenge det er nødvendig for formålet
        de ble samlet inn for, eller så lenge vi er lovpålagt å gjøre det (for
        eksempel etter regnskapsloven).
      </p>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        6. Kilder
      </h2>
      <p className="mb-4">
        Opplysninger samles i hovedsak inn direkte fra deg (ved registrering,
        bestilling eller henvendelse). Tekniske data kan innhentes automatisk
        fra din enhet/nettleser ved bruk av nettstedet.
      </p>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        7. Deling av opplysninger
      </h2>
      <p className="mb-2">
        Vi deler ikke personopplysninger med tredjeparter med mindre det er
        nødvendig for å levere tjenester eller oppfylle lovkrav. Dette kan
        omfatte:
      </p>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>
          <strong>Tjenesteleverandører</strong> (f.eks. IT-drift, betaling,
          e-post).
        </li>
        <li>
          <strong>Myndigheter</strong> når det er påkrevd ved lov.
        </li>
      </ul>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        8. Overføring utenfor EØS
      </h2>
      <p className="mb-4">
        Dersom personopplysninger overføres utenfor EØS, vil vi sikre at
        overføringen har gyldig rettslig grunnlag (f.eks. standard
        kontraktsklausuler) og at tilstrekkelig beskyttelse ivaretas.
      </p>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        9. Informasjonssikkerhet
      </h2>
      <p className="mb-4">
        Vi benytter tekniske og organisatoriske tiltak for å beskytte
        opplysningene mot uautorisert tilgang, endring, tap eller misbruk.
      </p>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        10. Dine rettigheter
      </h2>
      <ul className="list-disc pl-6 space-y-1 mb-4">
        <li>Innsyn i hvilke opplysninger vi har om deg.</li>
        <li>Korrigering av uriktige/ucomplete opplysninger.</li>
        <li>Sletting (der det er grunnlag for det).</li>
        <li>Begrensning av behandling i bestemte tilfeller.</li>
        <li>Protestere mot behandling for markedsføring.</li>
        <li>Dataportabilitet i gitte situasjoner.</li>
      </ul>
      <p className="mb-4">
        Du kan klage til Datatilsynet dersom du mener at vår behandling er i
        strid med regelverket. Se{" "}
        <span className="whitespace-nowrap">www.datatilsynet.no</span> for mer info.
      </p>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        11. Informasjonskapsler (cookies)
      </h2>
      <p className="mb-4">
        Vi bruker informasjonskapsler for å forbedre brukeropplevelsen. Du kan
        administrere cookies i nettleseren. Dersom vi bruker tredjeparts
        analyse-/markedsføringsverktøy, vil dette fremgå av vår cookie-policy.
      </p>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        12. Automatiserte avgjørelser
      </h2>
      <p className="mb-4">
        Vi foretar ikke beslutninger utelukkende basert på automatisert
        behandling som har rettsvirkning eller tilsvarende betydelig effekt for
        deg.
      </p>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        13. Endringer i denne erklæringen
      </h2>
      <p className="mb-4">
        Vi kan oppdatere erklæringen ved behov. Oppdatert versjon publiseres på
        denne siden med ny dato øverst.
      </p>

      <h2 className="text-xl font-semibold text-[#000099] mt-8 mb-2">
        14. Kontaktinformasjon
      </h2>
      <address className="not-italic mb-10">
        Ryfylke Utleie AS
        <br />
        E-post: <a className="underline" href="mailto:hallgeir@ryfylketransport.no">hallgeir@ryfylketransport.no</a>
      </address>
    </div>
  );
}
